import { Skeleton as ShadcnSkeleton } from "../skeleton";

// Direct re-export for compatibility
export const Skeleton = ShadcnSkeleton;
